import moment from 'moment';
import { Media } from '../../../../mediaSetting';
import { useMediaQuery } from 'react-responsive';
import { useDispatch, useSelector } from 'react-redux';
import { breakpoints } from '../../../../mediaSetting.js';
import { getTimezones } from '../../../../actions/user.js';
import { Container, Image, Grid } from 'semantic-ui-react';
import React, { Fragment, useEffect, useState } from 'react';
import { NetworkTypes } from '../../../../constants/networkTypes.js';

const UserProfileCenterPanelReadOnly = (props) => {
  const dispatch = useDispatch();

  const backgroundIfDefaultImage = 'color-gray-bg';
  const mobileCheck = useMediaQuery({
    query: `(max-width: ${breakpoints.computer}px)`,
  });

  const { selectedUser, isAdmin, userCallsDetails } = props;

  const {
    email,
    suffix,
    timezone,
    lastName,
    firstName,
    invitedBy,
    honorific,
    userImageUrl,
    personStatus,
    lastLoginDate,
    waitingAreaAlias,
    accountCreatedDate,
  } = selectedUser;

  const {
    Suffix,
    Honorific,
    LastName,
    FirstName,
    InvitedBy,
    NoLastCall,
    NotProvided,
    LastTenCalls,
    EmailAddress,
    PersonStatus,
    LastLoginDate,
    SelectTimezone,
    WaitingAreaAlias,
    AccountCreatedDate,
    ProfileImgCaption1,
    ProfileImgCaption2,
  } = APP.LANGUAGE.UserProfile;

  const tableHeads = [{ key: 'Name/OU' }, { key: 'Date' }, { key: 'Start' }, { key: 'Duration' }];

  const personStatuses = {
    A: 'Active',
    E: 'In active',
    I: 'Invited',
  };

  const [rotate, setRotate] = useState(0);
  const [profileImageDroppedScale, setProfileImageDroppedScale] = useState(1);

  const timezones = useSelector((state) => state.usersReducer.timezones);
  const userProfile = useSelector((state) => state.usersReducer.userProfile);
  const isProfileImageEditable = useSelector((state) => state.usersReducer.isProfileImageEditable);

  useEffect(() => {
    dispatch(getTimezones());
  }, []);

  const setRotation = (rotatePic) => {
    setRotate(rotatePic);
  };

  const setProfileImageDroppedScaleMethod = (profileImageDroppedScale) => {
    setProfileImageDroppedScale(profileImageDroppedScale);
  };

  const getTimeZoneText = (selectedTimezone) => {
    if (timezones && timezones.length > 0) {
      const timeZone = timezones.find((x) => x.value == selectedTimezone);
      if (timeZone) return timeZone.text;
      return selectedTimezone;
    } else {
      return '';
    }
  };

  const getConvertedDate = (lastLoginDate) => {
    const date = moment.utc(lastLoginDate);
    return `${date.format('dddd, MMMM Do YYYY')} ${date.format('LT')}`;
  };

  const getNetworkIcon = (networkId) => {
    if (networkId === NetworkTypes.WaitingArea) {
      return <Image src={APP.IMAGES.WaitingAreaIcon.default} className="centerAlignNetworkTypeIcon" circular />;
    } else if (networkId === NetworkTypes.MeetingRoom) {
      return <Image src={APP.IMAGES.MeetingRoomIcon.default} className="centerAlignNetworkTypeIcon" circular />;
    } else if (networkId === NetworkTypes.GroupConsultation) {
      return <Image src={APP.IMAGES.GCWaitingAreaIcon.default} className="centerAlignNetworkTypeIcon" circular />;
    } else if (networkId === NetworkTypes.Organisation) {
      return <Image src={APP.IMAGES.OrgUnitsIcon.default} className="centerAlignNetworkTypeIcon" circular />;
    }
  };

  const callListTable = () => {
    return (
      <div className={`${mobileCheck ? 'call-list-main-container' : ''}`}>
        <div className={`${mobileCheck ? 'call-list-mobile-view' : 'call-list-table'} flexible ui grid`}>
          <div className="row flexible border-bottom">
            {isAdmin &&
              tableHeads.map((head, index) => (
                <Fragment key={index}>
                  {/* for computer only */}
                  <div
                    className={`ui computer only left-text column no-padding-left bold ${
                      index === 0 ? 'seven' : 'three'
                    } wide`}
                  >
                    {head.key}
                  </div>

                  {/* for tablet and mobile */}
                  <div
                    className={`ui tablet mobile only left-text column bold ${index === 0 ? 'seven' : 'three'} wide`}
                  >
                    {head.key}
                  </div>
                </Fragment>
              ))}
          </div>

          {isAdmin &&
            userCallsDetails?.map((user, index) => {
              let iconNetworkType = getNetworkIcon(user.networkTypeId);
              return (
                <div className={'row flexible border-bottom'} key={index}>
                  <div className={'ui one wide computer only left-text column centerAlignNetworkTypeIcon'}>
                    {iconNetworkType}
                  </div>
                  <div className={'ui one wide  tablet mobile only left-text column centerAlignNetworkTypeIcon'}>
                    {iconNetworkType}
                  </div>

                  {/* for computer only */}
                  <div className={'ui six wide computer only left-text column centerAlignVertical wrap-link'}>
                    {user.name}
                    <br /> <div className={'mobileSecondRow text-size-ms'}>{user.organization}</div>
                  </div>
                  <div className={'ui three wide computer only left-text column no-padding-left'}>{user.date}</div>
                  <div className={'ui three wide computer only left-text column white-space-now-rap no-padding-left'}>
                    {user.time}
                  </div>
                  <div className={'ui three wide computer only left-text column no-padding-left'}>
                    {user.duration !== '' && user.duration === null ? '--:--:--' : user.duration}
                  </div>

                  {/* for tablet and mobile */}
                  <div className={'ui six wide tablet mobile only left-text column centerAlignVertical wrap-link'}>
                    {user.name}
                    <br /> <div className={'mobileSecondRow text-size-ms'}>{user.organization}</div>
                  </div>
                  <div className={'ui three wide tablet mobile only left-text column centerAlignVertical wrap-link'}>
                    {user.date}
                  </div>
                  <div className={'ui three wide tablet mobile only left-text column centerAlignVertical wrap-link'}>
                    {user.time}
                  </div>
                  <div className={'ui three wide tablet mobile only left-text column centerAlignVertical wrap-link'}>
                    {user.duration !== '' && user.duration === null ? '--:--:--' : user.duration}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  };

  return (
    <span>
      <div className="ui fluid form">
        <div className="ui sixteen column grid mrtnull mrbl">
          <div className="pdtnull sixteen wide column details-section checkLeft">
            <div className=" mrtm">
              <div
                className={`ui sixteen column grid hide-on-mobile padding-bottom-0
                ${isAdmin ? 'profile-container overflow-scroll' : 'overflow-hidden'}`}
              >
                <div className="ten wide column pdtnull padding-bottom-0">
                  <div className="placeholder-label color-placeholder">{Honorific}</div>
                  <div className="title-sms mrbm">{honorific || NotProvided}</div>
                  <div className="placeholder-label color-placeholder">{FirstName}</div>
                  <div className="title-sms mrbm">{firstName || NotProvided}</div>
                  <div className="placeholder-label color-placeholder">{LastName}</div>
                  <div className="title-sms mrbm">{lastName || NotProvided}</div>
                  <div className="placeholder-label color-placeholder">{Suffix}</div>
                  <div className="title-sms mrbm">{suffix || NotProvided}</div>
                  <div className="placeholder-label color-placeholder">{SelectTimezone}</div>
                  <div className="title-sms mrbm">{getTimeZoneText(timezone) || NotProvided}</div>
                  <div className="placeholder-label color-placeholder">{EmailAddress}</div>
                  <div className="title-sms mrbm">{email || NotProvided}</div>
                  <div className="placeholder-label color-placeholder">{WaitingAreaAlias}</div>
                  <div className="title-sms mrbm">{waitingAreaAlias || NotProvided}</div>
                  {isAdmin && (
                    <>
                      <div className="placeholder-label color-placeholder">{AccountCreatedDate}</div>
                      <div className="title-sms mrbm white-space-now-rap">
                        {(accountCreatedDate && getConvertedDate(accountCreatedDate)) || NotProvided}
                      </div>
                      <div className="placeholder-label color-placeholder">{LastLoginDate}</div>
                      <div className="title-sms mrbm white-space-now-rap">
                        {(lastLoginDate && getConvertedDate(lastLoginDate)) || NotProvided}
                      </div>
                      <div className="placeholder-label color-placeholder">{PersonStatus}</div>
                      <div className="title-sms mrbm">{personStatuses[personStatus] || NotProvided}</div>
                      <div className="placeholder-label color-placeholder">{InvitedBy}</div>
                      <div className="title-sms mrbm white-space-now-rap">{invitedBy || NotProvided}</div>
                      <div className="placeholder-label color-placeholder">{LastTenCalls}</div>
                    </>
                  )}
                </div>
                <Container
                  fluid
                  as={Media}
                  greaterThanOrEqual="tablet"
                  className="six wide column alignImageWithTop mrbnull pdbnull"
                >
                  <div className="drop-zone pointer pdtnull" accept="image/*">
                    <div className="canvas-holder" onWheel={() => {}}>
                      {' '}
                      <img src={userImageUrl || userProfile.defaultImageUrl} />
                      <div className="placeholder-label color-placeholder">{ProfileImgCaption1}</div>
                      <div className="placeholder-label color-placeholder">{ProfileImgCaption2}</div>
                    </div>
                  </div>
                </Container>
                {isAdmin && (
                  <>
                    {userCallsDetails.length === 0 && <div className="title-sms mrbm">{NoLastCall}</div>}
                    {userCallsDetails.length !== 0 && <>{callListTable()}</>}
                  </>
                )}
              </div>
              <div className="show-on-mobile">
                <div className="placeholder-label color-placeholder">{Honorific}</div>
                <div className="title-sms mrbm">{honorific || NotProvided}</div>
                <div className="placeholder-label color-placeholder">{FirstName}</div>
                <div className="title-sms mrbm">{firstName || NotProvided}</div>
                <div className="placeholder-label color-placeholder">{LastName}</div>
                <div className="title-sms mrbm">{lastName || NotProvided}</div>
                <div className="placeholder-label color-placeholder">{Suffix}</div>
                <div className="title-sms mrbm">{suffix || NotProvided}</div>
                <div className="placeholder-label color-placeholder">{SelectTimezone}</div>
                <div className="title-sms mrbm">{getTimeZoneText(timezone) || NotProvided}</div>
                <div className="placeholder-label color-placeholder">{EmailAddress}</div>
                <div className="title-sms mrbm">{email || NotProvided}</div>
                <div className="placeholder-label color-placeholder">{WaitingAreaAlias}</div>
                <div className="title-sms mrbm">{waitingAreaAlias || NotProvided}</div>
                {isAdmin && (
                  <>
                    <div className="placeholder-label color-placeholder">{AccountCreatedDate}</div>
                    <div className="title-sms mrbm white-space-now-rap">
                      {(accountCreatedDate && getConvertedDate(accountCreatedDate)) || NotProvided}
                    </div>
                    <div className="placeholder-label color-placeholder">{LastLoginDate}</div>
                    <div className="title-sms mrbm white-space-now-rap">
                      {(lastLoginDate && getConvertedDate(lastLoginDate)) || NotProvided}
                    </div>
                    <div className="placeholder-label color-placeholder">{PersonStatus}</div>
                    <div className="title-sms mrbm">{personStatuses[personStatus] || NotProvided}</div>
                    <div className="placeholder-label color-placeholder">{InvitedBy}</div>
                    <div className="title-sms mrbm">{invitedBy || NotProvided}</div>
                    <div className="placeholder-label color-placeholder">{LastTenCalls}</div>
                    {isAdmin && (
                      <>
                        {userCallsDetails.length === 0 && <div className="title-sms mrbm">{NoLastCall}</div>}
                        {userCallsDetails.length !== 0 && <>{callListTable()}</>}
                      </>
                    )}
                  </>
                )}
                <Container fluid as={Media} at="mobile" className="mrtl">
                  <div className="canvas-holder" onWheel={() => {}}>
                    {' '}
                    <img src={userImageUrl || userProfile.defaultImageUrl} />
                    <div className="placeholder-label color-placeholder center-text">{ProfileImgCaption1}</div>
                    <div className="placeholder-label color-placeholder center-text">{ProfileImgCaption2}</div>
                  </div>
                </Container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </span>
  );
};
export default UserProfileCenterPanelReadOnly;
